export const movieGenres = ["全部", "动作", "科幻", "喜剧", "爱情", "恐怖", "剧情", "动画", "悬疑", "战争", "犯罪", "奇幻", "惊悚", "冒险", "灾难", "赛车", "家庭", "古装"];

export const tvGenres = ["全部", "剧情", "古装", "悬疑", "爱情", "都市", "喜剧", "科幻", "历史", "武侠", "家庭", "犯罪", "青春", "仙侠", "权谋", "战争"];

export const regions = ["全部", "中国大陆", "美国", "香港", "韩国", "日本", "英国", "法国", "印度"];

export const years = ["全部", "2024", "2023", "2022", "2021", "2020"];

export const episodeRanges = ["全部", "12集以下", "12-24集", "25-40集", "40集以上"];

export const sortOptions = [
  { value: "updated", label: "按更新时间" },
  { value: "hot", label: "按热度" },
  { value: "rating", label: "按评分" },
];